import React from "react";
import LegalLayout from "./LegalLayout";

export default function TermsOfService() {
  return (
    <LegalLayout title="Termos de Uso" lastUpdate="Abril de 2026">
      <Section n="1" title="Aceitação dos Termos">
        <p>Ao utilizar a plataforma, o usuário concorda integralmente com estes Termos de Serviço.</p>
      </Section>

      <Section n="2" title="Objeto">
        <p>A plataforma oferece intermediação para agendamento e realização de consultas psicológicas entre pacientes e profissionais.</p>
      </Section>

      <Section n="3" title="Cadastro">
        <p>O usuário é responsável por:</p>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Fornecer informações verdadeiras</li>
          <li>Manter seus dados atualizados</li>
          <li>Garantir a segurança de sua conta</li>
        </ul>
      </Section>

      <Section n="4" title="Planos e Créditos">
        <h3 className="text-base font-semibold mt-4 mb-1">4.1 Validade dos Planos</h3>
        <p>Os planos contratados possuem prazo determinado.</p>
        <Callout>👉 Os créditos adquiridos devem ser utilizados dentro do período de vigência do plano.</Callout>
        <h3 className="text-base font-semibold mt-4 mb-1">4.2 Expiração de Créditos</h3>
        <p>Caso os créditos não sejam utilizados dentro do prazo:</p>
        <Callout danger>⚠️ <strong>Os créditos serão automaticamente expirados, sem possibilidade de reembolso ou transferência.</strong></Callout>
      </Section>

      <Section n="5" title="Regras de Agendamento">
        <h3 className="text-base font-semibold mt-4 mb-1">5.1 Limite de Sessões</h3>
        <p>O cliente poderá agendar:</p>
        <Callout>👉 <strong>No máximo 2 (duas) sessões por semana</strong></Callout>
        <p>Essa regra visa garantir qualidade no atendimento e organização da agenda.</p>
        <h3 className="text-base font-semibold mt-4 mb-1">5.2 Cancelamentos</h3>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Cancelamentos devem ser feitos com antecedência mínima definida pela plataforma</li>
          <li>Ausências podem implicar na perda do crédito</li>
        </ul>
      </Section>

      <Section n="6" title="Responsabilidades">
        <h3 className="text-base font-semibold mt-4 mb-1">6.1 Do Usuário</h3>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Comparecer às sessões agendadas</li>
          <li>Utilizar a plataforma de forma ética</li>
        </ul>
        <h3 className="text-base font-semibold mt-4 mb-1">6.2 Da Plataforma</h3>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Garantir funcionamento do sistema</li>
          <li>Intermediar agendamentos</li>
        </ul>
        <p>A plataforma não substitui atendimento emergencial.</p>
      </Section>

      <Section n="7" title="Uso Indevido">
        <p>É proibido:</p>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Fornecer informações falsas</li>
          <li>Utilizar a plataforma para fins ilícitos</li>
          <li>Desrespeitar profissionais</li>
        </ul>
      </Section>

      <Section n="8" title="Limitação de Responsabilidade">
        <p>A plataforma atua como intermediadora e não se responsabiliza por:</p>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Condutas individuais dos profissionais</li>
          <li>Resultados terapêuticos</li>
        </ul>
      </Section>

      <Section n="9" title="Privacidade">
        <p>O uso da plataforma também está sujeito à Política de Privacidade.</p>
      </Section>

      <Section n="10" title="Alterações">
        <p>Os Termos podem ser atualizados a qualquer momento.</p>
      </Section>

      <Section n="11" title="Foro">
        <p>Fica eleito o foro da comarca do Profissional ou da sede da plataforma, conforme legislação aplicável.</p>
      </Section>
    </LegalLayout>
  );
}

function Section({ n, title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="text-xl md:text-2xl font-semibold tracking-tight" style={{fontFamily:"'Outfit',sans-serif"}}>{n}. {title}</h2>
      <div className="space-y-2 text-[hsl(var(--text-secondary))]">{children}</div>
    </section>
  );
}

function Callout({ children, danger }) {
  return (
    <div className={`rounded-lg p-3 my-2 text-sm ${danger ? "bg-[hsl(var(--danger-bg))] text-[hsl(var(--danger-text))]" : "bg-[hsl(var(--brand-light))]/50 text-[hsl(var(--text-primary))]"}`}>
      {children}
    </div>
  );
}
